<template>
  <div
    v-click-away="close"
    class="dots-dropdown"
    :class="{ 'open-top': openOnTop, active: isOpened }"
    @click.stop="toggle"
  >
    <div v-if="isOpened" class="dots-dropdown__list">
      <slot name="list-actions" />
      <div class="list-footer">
        <slot name="list-footer" />
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from '@tools/event-bus';

export default {
  name: 'DotsDropdown',
  props: {
    dropdownId: { type: String, required: true },
    openOnTop: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpened: false,
    };
  },
  mounted() {
    /**
     * Only one dropdown can be opened at a time (if there are multiple dots dropdown component in the same page)
     */
    eventBus.addEventListener('dots.dropdown.toggle', (event) => {
      if (this.dropdownId !== event.detail.dropdownIdToggled) {
        this.close();
      }
    });
  },
  methods: {
    toggle() {
      this.isOpened = !this.isOpened;
      eventBus.dispatchEvent(new CustomEvent('dots.dropdown.toggle', {
        detail: {
          dropdownIdToggled: this.$props.dropdownId,
        },
      }));
    },
    close() {
      this.isOpened = false;
    },
  },
};
</script>
